import {Component} from '@angular/core';
import {TitleService} from '../../services/title.service';

@Component({
  selector: `demo-component`,
  templateUrl: 'demo.component.html'
})
export class DemoComponent {
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('Sales and Demo');
  }
}
